
let phoneNumbers = {
    'en': '+44 74 607 37692',
    'da': '+358 40 938 8774' ,
    'fi': '+358 40 938 8774',
    'fr': '+44 74 607 37692' ,
    'de': '+44 74 607 37692' ,
    'it': '+39 029 475 8516' ,
    'lv': '+358 40 938 8774' ,
    'ru': '+358 40 938 8774' ,
    'es': '+34 625 820 282' ,
    'sv': '+358 40 938 8774' ,
    'zh': '+44 74 607 37692'
}
    
export default phoneNumbers;